import CircularProgress from "@mui/material/CircularProgress";
import type { SxStyles } from "core/utilities/theme";
import React from "react";

function ButtonLoading({ sx }: { sx?: SxStyles }) {
  return (
    <CircularProgress
      size={24}
      thickness={4}
      disableShrink
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: "-12px",
        marginLeft: "-12px",
        ...sx,
      }}
    />
  );
}

export default ButtonLoading;
